module.exports = __webpack_public_path__ + "929e3438cd301cdab3de2ce27101e029.png";